<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="transparent" flat elevation="0">
							<v-toolbar-title class="ml-0" v-if="oauth_provider.service_name"
								>{{ $t("lang.oauth_provider") + " - " + oauth_provider.service_name }}<bc-breadcrumbs :items="breadcrumb_items"></bc-breadcrumbs
							></v-toolbar-title>
							<v-spacer></v-spacer>
							<bc-btn-refresh @invoke-method="dbGetOauthProvider(true)"></bc-btn-refresh>
							<!-- <bc-search-menu :params="axiosParams">
								<v-list>
									<v-list-tile>
										<bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
									</v-list-tile>
								</v-list>
							</bc-search-menu> -->
							<bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
						</v-toolbar>
					</v-layout>
				</v-container>
			</v-card>

			<v-card-text>
				<v-card elevation="0">
					<v-card-text style="background-color: white">
						<v-form ref="formOauthProvider">
							<v-flex xs12 v-if="$isSet(oauth_provider.oauth_tokens) && oauth_provider.oauth_tokens.length !== 0" mb-4>
								<v-layout mb-2>
									<v-icon color="success">hgi hgi-solid hgi-checkmark-circle-02</v-icon>
									<v-flex pl-2 fs-22>{{ $t("lang.authorized") }}</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.client_id"
									:label="$t('lang.client_id')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_providers.client_id')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.client_secret"
									:label="$t('lang.client_secret')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_providers.client_secret')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="oauth_provider.org_id"
									:label="$t('lang.org_id')"
									:counter="showCounter(oauth_provider.org_id, 'oauth_provider.org_id')"
									:rules="ifValid('oauth_providers.org_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.scopes"
									:label="$t('lang.scopes')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_providers.scopes')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.auth_uri"
									:label="$t('lang.auth_uri')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_providers.auth_uri')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.redirect_uri"
									:label="$t('lang.redirect_uri')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_providers.redirect_uri')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.redirect_auth_uri"
									:label="$t('lang.redirect_auth_uri')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_providers.redirect_auth_uri')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.api_base"
									:label="$t('lang.api_base')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_providers.api_base')"
								></v-textarea>
							</v-flex>
							<!-- <v-flex xs12>
								<v-text-field
									v-focus="oauth_provider_dialog"
									v-model="oauth_provider.provider_id"
									:label="`${$t('lang.provider_id')} *`"
									:rules="ifValid('oauth_provider.provider_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="oauth_provider.provider_id"
									:label="`${$t('lang.provider_id')} *`"
									:rules="ifValid('oauth_provider.provider_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="oauth_provider.third_party"
									:label="$t('lang.third_party')"
									:counter="showCounter(oauth_provider.third_party, 'oauth_provider.third_party')"
									:rules="ifValid('oauth_provider.third_party')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="oauth_provider.service_name"
									:label="`${$t('lang.service_name')} *`"
									:counter="showCounter(oauth_provider.service_name, 'oauth_provider.service_name')"
									:rules="ifValid('oauth_provider.service_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="oauth_provider.logo"
									:label="$t('lang.logo')"
									:counter="showCounter(oauth_provider.logo, 'oauth_provider.logo')"
									:rules="ifValid('oauth_provider.logo')"
								></v-text-field>
							</v-flex>
							
							
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.client_id"
									:label="$t('lang.client_id')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_provider.client_id')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="oauth_provider.org_id"
									:label="$t('lang.org_id')"
									:counter="showCounter(oauth_provider.org_id, 'oauth_provider.org_id')"
									:rules="ifValid('oauth_provider.org_id')"
								></v-text-field>
							</v-flex>
							
							<v-flex xs12>
								<v-textarea
									v-model="oauth_provider.client_secret"
									:label="$t('lang.client_secret')"
									auto-grow
									rows="1"
									:rules="ifValid('oauth_provider.client_secret')"
								></v-textarea>
							</v-flex>
							
							
							
							
							
							<v-flex xs12>
								<v-text-field
									v-model="oauth_provider.redirect_auth_uri"
									:label="`${$t('lang.redirect_auth_uri')} *`"
									:counter="showCounter(oauth_provider.redirect_auth_uri, 'oauth_provider.redirect_auth_uri')"
									:rules="ifValid('oauth_provider.redirect_auth_uri')"
								></v-text-field>
							</v-flex> -->
						</v-form>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn @mouseup.left="handleAuthorization" color="primary">{{
								$isSet(oauth_provider.oauth_tokens) ? $t("lang.re_authorize") : $t("lang.authorize")
							}}</v-btn>

							<v-btn color="success" @click="saveOauthProviders">{{ $t("lang.save") }}</v-btn>
						</v-card-actions>
					</v-card-text>
				</v-card>
			</v-card-text>

			<delete-confirmation-dialog
				ref="delete_oauth_provider"
				headline="Confirm Delete?"
				:heading="$t('lang.delete_oauth_provider')"
				:message="$t('lang.delete_oauth_provider_confirm')"
				@onConfirm="deleteOauthProviders()"
			></delete-confirmation-dialog>
			<delete-confirmation-dialog
				ref="delete_oauth_provider_details"
				:heading="$t('lang.delete_package')"
				@onConfirm="confirmDeleteOauthProviderDetails()"
			></delete-confirmation-dialog>
		</v-container>
	</div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import AppConfig from "@/application/constants/AppConfig.js";
import { store } from "Store/store";

export default {
	data() {
		return {
			appConfig: AppConfig,
			mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
			filter: {
				search: "",

				page_size: 0,
				page_num: 0,
			},
			formData: {},
			oauth_provider: {},
			file_name: "",
			dbGetOauthProvider: _.debounce(this.getOauthProvider, 1500, { maxWait: 1500, leading: true, trailing: false }),
			customers: null,
			oauth_provider_dialog: false,
			breadcrumb_items: [
				{
					text: "Dashboard",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "dashboard",
					},
				},
				{
					text: "Integrations",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "configuration",
						params: { tab: 2 },
					},
				},
				{
					text: this.$route.params.third_party || "unknown provider",
					disabled: true,
					href: "",
				},
			],
		};
	},
	beforeRouteUpdate(to, from, next) {
		const id = `${to.params.third_party}`;

		if (id !== "undefined") {
			this.$store
				.dispatch("fetchOauthProvider", {
					id: id,
				})
				.then((data) => {
					if (typeof data !== "undefined" && data.oauth_provider) {
						this.oauth_provider = this.assignObj2(data.oauth_provider, this.rules_oauth_providers);

						this.$store.dispatch("fetchSetting", {
							url: "options?slug=oauth_provider_status&sort_by=2",
							method: "get",
							stateProperty: "oauth_provider_status_options",
							dataProperty: "options",
							commit: true,
						});

						this.finishLoader();
						next();
					} else {
						next({ name: "oauth_providers", replace: true });
					}
				});
		} else {
			this.finishLoader();
			next();
		}
	},
	beforeRouteEnter(to, from, next) {
		const id = `${to.params.third_party}`;

		if (id !== "undefined") {
			store
				.dispatch("fetchOauthProvider", {
					id: id,
				})
				.then((data) => {
					if (typeof data !== "undefined" && data.oauth_provider) {
						next((vm) => {
							vm.oauth_provider = vm.assignObj2(data.oauth_provider, vm.rules_oauth_providers);

							store.dispatch("fetchSetting", {
								url: "options?slug=oauth_provider_status&sort_by=2",
								method: "get",
								stateProperty: "oauth_provider_status_options",
								dataProperty: "options",
								commit: true,
							});

							vm.finishLoader();
						});
					} else {
						next({ name: "oauth_providers", replace: true });
					}
				});
		} else {
			next((vm) => {
				vm.finishLoader();
			});
		}

		/*store.dispatch("fetchSetting", {
            url: "options?slug=oauth_provider_status&sort_by=2",
            method: "get",
            stateProperty: "oauth_provider_status_options",
            dataProperty: "options",
            commit: true,
        });*/
	},
	computed: {
		...mapState({
			rules_oauth_providers: (state) => state.oauth_provider.rules_oauth_providers,
			oauth_provider_status_options: (state) => state.settings.oauth_provider_status_options,
			oauth_providers: (state) => state.oauth_providers,
			selectedOauthProvider: (state) => state.selectedOauthProvider,
		}),
		axiosParams() {
			return this.prepareParams(this.filter, this.default_filter);
		},
	},
	methods: {
		...mapActions(["fetchOauthProvider", "saveOauthProvider", "deleteOauthProvider", "printOauthProvider"]),
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader", "clearOauthProviders"]),

		getOauthProvider(pg_refresh = false) {
			this.startLoader();

			this.fetchOauthProvider({
				id: `${this.$route.params.third_party}`,
			}).then((data) => {
				if (typeof data !== "undefined" && data.oauth_provider) {
					this.oauth_provider = this.assignObj2(data.oauth_provider, this.rules_oauth_providers);
					this.toggleModalLoader(false);
					this.validationOff();
					this.finishLoader(pg_refresh);
				}
			});
		},
		printPDF() {
			this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

			this.printOauthProvider({
				id: `${this.$route.params.id}`,
			}).then((data) => {
				if (typeof data != "undefined" && data.oauth_provider) {
					if (this.dev_mode) {
						this.file_name = data.oauth_provider.file_name;
					} else {
						this.$refs.print.printReport(data.oauth_provider.file_name);
					}

					if (!this.dev_mode) this.toggleGlobalSnackbar(false);
				} else {
					this.file_name = "";
					this.$refs.print.close();
					this.createAlert();
				}
			});
		},
		saveOauthProviders() {
			this.validationOn();
			// Remove the logo property from the oauth_provider object
			delete this.oauth_provider.logo;

			this.$nextTick(() => {
				if (this.validateForm("formOauthProvider")) {
					let body = this.prepForm(this.oauth_provider, this.rules_oauth_providers);

					this.saveOauthProvider({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							this.getOauthProvider();
							this.validationOff();
						} else {
						}
					});
				}
			});
		},
		changeStatus(item) {
			this.status_loader = true;
			let body = { provider_id: `${this.$route.params.id}`, status_id: item.option_id };

			this.saveOauthProviders({
				body: body,
			}).then((data) => {
				if (typeof data != "undefined" && data.oauth_provider) {
					this.oauth_provider = this.assignObj2(data.oauth_provider, this.rules_oauth_providers);
				}
			});
		},
		deleteOauthProviders() {
			this.deleteOauthProvider({
				id: `${this.$route.params.id}`,
			}).then((data) => {
				if (data && data.code == "200") {
					this.validationOff();
					this.$router.push({ name: "oauth_providers" });
				}
				this.toggleModalLoader(false);
			});
		},
		handleAuthorization() {
			if (this.$route.params.third_party) {
				window.location.href = `${this.appConfig.baseApiUrl}/oauth/authorize/${this.$route.params.third_party}`;
			}
		},
		async refresh(force = false) {
			this.startLoader();

			if (force == true) {
				await this.fetchOauthProvider({
					id: `${this.$route.params.id}`,
				}).then((data) => {
					if (typeof data !== "undefined" && data.oauth_provider) {
						this.oauth_provider = this.assignObj2(data.oauth_provider, this.rules_oauth_providers);
						this.toggleModalLoader(false);
						this.validationOff();
						this.finishLoader(true);
					}
				});
			} else {
				this.finishLoader();
			}
		},
	},
	mounted() {
		this.refresh();
		// this.debugInterval = setInterval(() => {
		// 	console.log(this.rules_oauth_providers);
		// }, 5000);
	},
	created() {},
	beforeRouteLeave(to, from, next) {
		this.$store.commit("clearOauthProviders");
		next();
	},
};
</script>
